import { useWizard } from '../../../context/WizardContext';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import { cn } from '../../../lib/utils';
import { Check } from 'lucide-react';

const LEVELS = [
  {
    value: 10,
    label: 'SSC',
    fullName: 'Secondary School Certificate',
    banglaName: 'মাধ্যমিক',
    classes: 'Class 9 – 10',
    emoji: '📘',
    color: 'from-sky-400 to-blue-500',
    bg: 'bg-sky-50',
    ring: 'ring-sky-300',
  },
  {
    value: 12,
    label: 'HSC',
    fullName: 'Higher Secondary Certificate',
    banglaName: 'উচ্চ মাধ্যমিক',
    classes: 'Class 11 – 12',
    emoji: '🎓',
    color: 'from-brand-500 to-violet-600',
    bg: 'bg-brand-50',
    ring: 'ring-brand-300',
  },
];

export function Step0Class() {
  const { state, setClass } = useWizard();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">Select Level</h2>
        <p className="text-sm text-slate-500 mt-1">
          Choose the examination level for which you want to generate questions.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {LEVELS.map((level) => {
          const isSelected = state.selectedClass === level.value;
          return (
            <button
              key={level.value}
              type="button"
              onClick={() => setClass(level.value)}
              className={cn(
                'relative flex flex-col items-center gap-4 rounded-2xl border-2 p-8 transition-all duration-200 focus:outline-none group',
                isSelected
                  ? `border-transparent ${level.bg} ring-2 ${level.ring} shadow-md`
                  : 'border-slate-700 bg-slate-700/50 hover:border-slate-600 hover:shadow-card-hover hover:-translate-y-0.5'
              )}
            >
              {isSelected && (
                <span className="absolute top-3 right-3 flex h-5 w-5 items-center justify-center rounded-full bg-brand-600 text-white">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
              )}

              <div
                className={cn(
                  'flex h-16 w-16 items-center justify-center rounded-2xl text-3xl shadow-md transition-transform duration-300 group-hover:scale-105',
                  `bg-gradient-to-br ${level.color}`
                )}
              >
                {level.emoji}
              </div>

              <div className="text-center">
                <p
                  className={cn(
                    'text-3xl font-extrabold tracking-tight',
                    isSelected ? 'text-violet-300' : 'text-white'
                  )}
                >
                  {level.label}
                </p>
                <p className="text-sm font-medium text-slate-400 mt-1">{level.fullName}</p>
                <p className="text-sm text-slate-400">{level.banglaName}</p>
                <span className="mt-2 inline-block rounded-full bg-slate-700 px-2.5 py-0.5 text-xs font-medium text-slate-400">
                  {level.classes}
                </span>
              </div>
            </button>
          );
        })}
      </div>

      <NavigationButtons />
    </div>
  );
}
